var {
  useControlledState
} = require("@react-stately/utils");

/**
 * Provides state management for a search field.
 */
function useSearchFieldState(props) {
  let [value, setValue] = useControlledState($f7e1711a9e517c942ab938ede655$var$toString(props.value), $f7e1711a9e517c942ab938ede655$var$toString(props.defaultValue) || '', props.onChange);
  return {
    value,
    setValue
  };
}

exports.useSearchFieldState = useSearchFieldState;

function $f7e1711a9e517c942ab938ede655$var$toString(val) {
  if (val == null) {
    return;
  }

  return val.toString();
}
